import { CORE } from "./commonRepository";

/**
 * Create mesages
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Create = async (model) =>{
    try{
        const result = await CORE.post('v1/messages', model);
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * List of messages
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetAll = async (filter) =>{
    try{
        const result = await CORE.get('v1/messages', {
            params: filter
        });
        return result;
    }catch(error){
        return error.response;
    }
};
